import React from 'react'
import PropTypes from 'prop-types'
import TaxonFilter from './filters/TaxonFilter'
import SingleFilter from './filters/SingleFilter'
import PriceFilter from './filters/PriceFilter'
import RatingFilter from './filters/RatingFilter'
import { PlusLogo } from '../../core/icons'
import { RATING_FILTER, PRODUCER_FILTER, TAXON_FILTER, MIN_PRICE_FILTER, MAX_PRICE_FILTER, SUBSCRIPTION_PLAN_FILTER, ON_SALE_FILTER } from './constants'

/**
* `SidebarFilters` component houses all available filters for the
* `ProductSearchContainer`.
*/
function SidebarFilters(props) {
  const {
    onChange, getFallbackUrl, filters, aggregations, className, name, isLoading, ...rest
  } = props

  const classes = [
    'sidebar-filters',
    className || '',
  ]

  /**
  * onChange event handler. Wraps the `onChange` callback to also track the
  * changes made.
  *
  * @param changes {object}
  * @param eventAction {string} Event Action for Google Analytics event.
  * @param eventLabel {string} Event Label for Google Analytics event.
  */
  const onFilterChange = (changes, eventAction, eventLabel) => {
    $.track('event', name, eventAction, eventLabel)
    onChange(changes)
  }

  return (
    <div {...rest} className={classes.join(' ')}>
      <TaxonFilter
        title="Authors & Artists"
        value={filters[PRODUCER_FILTER]}
        aggregations={aggregations.significant_taxons}
        onChange={(value, eventLabel) => onFilterChange({ [PRODUCER_FILTER]: value }, 'Author', eventLabel)}
        getFallbackUrl={value => getFallbackUrl({ [PRODUCER_FILTER]: value })}
        isLoading={isLoading}
      />
      <SingleFilter
        title="Bookshelf PLUS"
        activeValue={aggregations.plus.subscriptions}
        value={filters[SUBSCRIPTION_PLAN_FILTER]}
        aggregations={aggregations.plus}
        onChange={(value, eventLabel) => onFilterChange({ [SUBSCRIPTION_PLAN_FILTER]: value }, 'Bookshelf PLUS', eventLabel)}
        getFallbackUrl={value => getFallbackUrl({ [SUBSCRIPTION_PLAN_FILTER]: value })}
        isLoading={isLoading}
      >
        <PlusLogo />
      </SingleFilter>
      <SingleFilter
        title="Promotions"
        activeValue
        value={filters[ON_SALE_FILTER]}
        aggregations={aggregations.onSale}
        onChange={(value, eventLabel) => onFilterChange({ [ON_SALE_FILTER]: value }, 'On Sale', eventLabel)}
        getFallbackUrl={value => getFallbackUrl({ [ON_SALE_FILTER]: value })}
        isLoading={isLoading}
      >
        <span className="has-text-sale">On Sale</span>
      </SingleFilter>
      <PriceFilter
        title="Price"
        minValue={filters[MIN_PRICE_FILTER]}
        maxValue={filters[MAX_PRICE_FILTER]}
        onChange={(min, max, eventLabel) => onFilterChange({ [MIN_PRICE_FILTER]: min, [MAX_PRICE_FILTER]: max }, 'Price', eventLabel)}
        getFallbackUrl={(min, max) => getFallbackUrl({ [MIN_PRICE_FILTER]: min, [MAX_PRICE_FILTER]: max })}
        isLoading={isLoading}
      />
      <RatingFilter
        title="Rating"
        value={filters[RATING_FILTER]}
        aggregations={aggregations.ratings}
        onChange={(value, eventLabel) => onFilterChange({ [RATING_FILTER]: value }, 'Rating', eventLabel)}
        getFallbackUrl={value => getFallbackUrl({ [RATING_FILTER]: value })}
        isLoading={isLoading}
      />
    </div>
  )
}

SidebarFilters.defaultProps = {
  aggregations: {},
  filters: {},
  isLoading: false,
  name: 'Sidebar Filters',
  getFallbackUrl: () => {},
}

SidebarFilters.propTypes = {
  // Search aggregations
  aggregations: PropTypes.object,
  // Object of currently applied filters.
  filters: PropTypes.object,
  // If more products are currently being requested.
  isLoading: PropTypes.bool,
  // Unique identifier that is used to group analytics events.
  name: PropTypes.string,
  // Helper function that generates a fallback url for a filter change.
  getFallbackUrl: PropTypes.func,
}

export default SidebarFilters
